import React from 'react';
import { connect } from 'react-redux';

import { Modal } from 'react-bootstrap';

import MapaService from '../services/mapa';
import { adicionarItem, atualizarItem, excluirItem } from '../actions/ItemActions';
import { editarCamposContrato } from '../actions/ContratoActions';

class DetalhesModuloPagamento extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      showModal: false,
      showModalCadastrarProduto: false,
      contrato: {},
      produtoSelecionado: {},
      dataMaximaPagto: "",
      novoProduto: {
        produto: "",
        quantidade: 0,
        preco: 0,
        observacao: "avulso",
        descricao: "",
        itens: ""
      },
      descontoComissao: "",
      carregandoAtualizarComissao: false
    };
    this.close = this.close.bind(this);
    this.open = this.open.bind(this);
  }

  open () {
    this.setState({ showModal: true, contrato: this.props.selecionado, dataMaximaPagto: this.props.selecionado.dataMaximaPagto ? this.props.selecionado.dataMaximaPagto.split("T")[0] : null});
    this.getPorcentagemDescontoComissao();
  }

  close () {
    this.setState({ showModal: false });
    this.props.atualizarContrato({
      id: this.state.contrato.id,
      sistemaPagto: this.state.contrato.sistemaPagto,
      avulsosLiberados: this.state.contrato.avulsosLiberados,
      parcelamentoNoBoleto: this.state.contrato.parcelamentoNoBoleto,
      dataMaximaPagto: this.state.contrato.dataMaximaPagto
    });
  }

  async getPorcentagemDescontoComissao () {
    const mapa = new MapaService(),
          response = await mapa.consultarDadosPagamentoOrcamento(this.props.selecionado.numOrcamento);

    if (response[0].descontoComissao) {
      this.setState({ descontoComissao: response[0].descontoComissao });
    }
  }

  async handleUpdateContrato (e) {
    const { name, checked } = e.target;

    await this.props.editarCamposContrato(this.state.contrato.id, { [name]: checked });
    this.setState({contrato: {...this.state.contrato, [name]: checked ? 1 : 0}});
  }
  
  async handleUpdateDataMaximaPagto () {
    let dataMaximaPagto = this.state.dataMaximaPagto;

    await this.props.editarCamposContrato(this.state.contrato.id, { dataMaximaPagto });
    this.setState({contrato: {...this.state.contrato, dataMaximaPagto }});
  }

  async handleUpdateDescontoComissao () {
    this.setState({ carregandoAtualizarComissao: true });
    const mapa = new MapaService(),
          response = await mapa.atualizarPorcentagemComissao({ numero: this.state.contrato.numOrcamento, comissao: this.state.descontoComissao });

    this.setState({ carregandoAtualizarComissao: false });
  }

  handleSubmitCadastrarProduto = async e => {
    e.preventDefault();

    let payload = {...this.state.novoProduto};

    payload.contrato = this.state.contrato.id;
    payload.tipo = payload.observacao === "brinde" ? "P" : "F";
    payload.ids = "undefined;";
    payload.adendo = 0;
    payload.valorAdendo = 0;
    
    await this.props.adicionarItem(payload);

    if (!this.props.itens.carregando) {
      if (this.props.itens.erro === null) {
        this.setState({
          showModalCadastrarProduto: false,
          contrato: {
            ...this.state.contrato,
            itens: [...this.state.contrato.itens, this.props.itens.ultimo]
          }
        });
      } else {
        this.setState({ showModalCadastrarProduto: false });
      }
    }
  }
  
  handleSubmitEditarProduto = async e => {
    e.preventDefault();

    let payload = { ...this.state.produtoSelecionado };
    payload.tipo = payload.observacao === "brinde" ? "P" : "F";

    await this.props.atualizarItem(payload);

    if (!this.props.itens.carregando) {
      if (this.props.itens.erro === null) {
        this.setState({
          showModalEditarProduto: false,
          contrato: {
            ...this.state.contrato,
            itens: [...this.state.contrato.itens].filter((item) => { return item.id !== payload.id }).concat(payload)
          }
        });
      } else {
        this.setState({ showModalEditarProduto: false });
      }
    }
  }

  handleSubmitExcluirProduto = async e => {
    e.preventDefault();

    let payload = { ...this.state.produtoSelecionado };

    await this.props.excluirItem(payload.id);

    if (!this.props.itens.carregando) {
      if (this.props.itens.erro === null) {
        this.setState({
          showModalExcluirProduto: false,
          contrato: {
            ...this.state.contrato,
            itens: [...this.state.contrato.itens].filter((item) => { return item.id !== payload.id })
          }
        });
      } else {
        this.setState({ showModalExcluirProduto: false });
      }
    }
  }

  render() {
    return (
      <Modal show={this.state.showModal} onHide={this.close} dialogClassName="modal-90w">
        <Modal.Header closeButton>
          <Modal.Title>Contrato {this.props.selecionado ? this.props.selecionado.numero : ""}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {
            this.state.contrato.id ?
              <div>
                <div className="row">
                  <div className="col-sm-12">
                    <div className="switch">
                      <input type="checkbox" name="sistemaPagto" defaultChecked={this.state.contrato.sistemaPagto} onChange={this.handleUpdateContrato.bind(this)} id="sistemaPagto" className="switch__input"/>
                      <label htmlFor="sistemaPagto" className="switch__label" style={{fontWeight: 400}}> Utiliza o módulo de pagamento on-line</label>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-12">
                    <div className="switch">
                      <input type="checkbox" name="avulsosLiberados" defaultChecked={this.state.contrato.avulsosLiberados} onChange={this.handleUpdateContrato.bind(this)} id="avulsosLiberados" className="switch__input"/>
                      <label htmlFor="avulsosLiberados" className="switch__label" style={{fontWeight: 400}}> Avulsos liberados</label>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-xs-12 col-sm-4">
                    <label htmlFor="descontoComissao">Desconto da comissão</label>
                    <div className="input-group">
                      <input type="number" name="descontoComissao" value={this.state.descontoComissao} onChange={e => this.setState({ descontoComissao: e.target.value })} id="descontoComissao" className="form-control"/>
                      <span className="input-group-btn">
                        <button className="btn btn-danger" type="button" onClick={this.handleUpdateDescontoComissao.bind(this)} disabled={this.state.carregandoAtualizarComissao}>
                          { this.state.carregandoAtualizarComissao ? <i className="fa fa-spin fa-spinner"></i> : <i className="fa fa-check"></i> }
                        </button>
                      </span>
                    </div>
                  </div>
                  <div className="col-xs-12 col-sm-4">
                    <label htmlFor="dataMaximaPagto">Data máxima de pagamento</label>
                    <div className="input-group">
                      <input type="date" name="dataMaximaPagto" value={this.state.dataMaximaPagto || ""} onChange={e => this.setState({ dataMaximaPagto: e.target.value })} id="dataMaximaPagto" className="form-control"/>
                      <span className="input-group-btn">
                        <button className="btn btn-danger" type="button" onClick={this.handleUpdateDataMaximaPagto.bind(this)}>
                          <i className="fa fa-check"></i>
                        </button>
                      </span>
                    </div>
                  </div>
                </div>
                <div style={{display: "flex", justifyContent: "flex-end"}}>
                  <button className="btn btn-link" onClick={() => this.setState({ showModalCadastrarProduto: true })}><i className="fa fa-plus"></i> Novo item</button>
                </div>
                <table className="table table-bordered table-hover">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Produto</th>
                      <th>Qtd</th>
                      <th>Preço</th>
                      <th>Tipo</th>
                      <th>Descrição</th>
                      <th>Itens</th>
                      <th>Ações</th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      this.state.contrato.itens.map((item, i) => 
                        <tr key={item.id}>
                          <td>{i + 1}</td>
                          <td>{item.produto}</td>
                          <td>{item.quantidade}</td>
                          <td>R$ {item.preco.toFixed(2).toLocaleString("pt-BR")}</td>
                          <td>{item.observacao}</td>
                          <td>{item.descricao}</td>
                          <td>
                            <ul>
                              {
                                item.itens.split(";").map((auxItem, j) => { 
                                  if (auxItem.length) return <li key={j}>{auxItem}</li>
                                  return null;
                                })
                              }
                            </ul>
                          </td>
                          <td>
                            <div style={{display: "flex"}}>
                              <button className="btn btn-link" onClick={() => this.setState({ showModalEditarProduto: true, produtoSelecionado: item })}><i className="fa fa-pencil"></i></button>
                              <button className="btn btn-link" onClick={() => this.setState({ showModalExcluirProduto: true, produtoSelecionado: item })}><i className="fa fa-trash"></i></button>
                            </div>
                          </td>
                        </tr>
                      )
                    }
                  </tbody>
                </table>
              </div>
            : <i className="fa fa-spinner fa-spin"></i>
          }
        </Modal.Body>

        <Modal show={this.state.showModalCadastrarProduto} onHide={() => this.setState({ showModalCadastrarProduto: false })}>
          <Modal.Header closeButton>
            <Modal.Title>Cadastrar produto</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div>
              <form onSubmit={this.handleSubmitCadastrarProduto}>
                <div className="form-group">
                  <label htmlFor="input-produto"><span className="perguntaObrigatoria">*</span>Produto</label>
                  <input type="text" id="input-produto" className="form-control" value={this.state.novoProduto.produto} onChange={e => this.setState({ novoProduto: { ...this.state.novoProduto, produto: e.target.value }})} required />
                </div>
                <div className="form-group">
                  <label htmlFor="input-quantidade"><span className="perguntaObrigatoria">*</span>Quantidade</label>
                  <input type="number" id="input-quantidade" className="form-control" value={this.state.novoProduto.quantidade} onChange={e => this.setState({ novoProduto: { ...this.state.novoProduto, quantidade: e.target.value }})} required />
                </div>
                <div className="form-group">
                  <label htmlFor="input-observacao"><span className="perguntaObrigatoria">*</span>Tipo</label>
                  <select id="input-observacao" className="form-control" value={this.state.novoProduto.observacao} onChange={e => this.setState({ novoProduto: { ...this.state.novoProduto, observacao: e.target.value, preco: (e.target.value === "brinde" ? 0 : this.state.novoProduto.preco)}})} required>
                    <option value="avulso">Avulso</option>
                    <option value="brinde">Brinde</option>
                    <option value="kit">Kit</option>
                  </select>
                </div>
                <div className="form-group">
                  <label htmlFor="input-preco"><span className="perguntaObrigatoria">*</span>Preço</label>
                  <input type="text" id="input-preco" className="form-control" value={this.state.novoProduto.preco} onChange={e => this.setState({ novoProduto: { ...this.state.novoProduto, preco: e.target.value }})} required disabled={this.state.novoProduto.observacao === "brinde"} />
                  <small>Utilize o . para valores decimais. Ex: 10.90</small>
                </div>
                <div className="form-group">
                  <label htmlFor="input-descricao"><span className="perguntaObrigatoria">*</span>Descrição</label>
                  <textarea id="input-descricao" className="form-control" value={this.state.novoProduto.descricao} onChange={e => this.setState({ novoProduto: { ...this.state.novoProduto, descricao: e.target.value }})} rows={3} required />
                </div>
                <div className="form-group">
                  <label htmlFor="input-itens"><span className="perguntaObrigatoria">*</span>Itens</label>
                  <textarea id="input-itens" className="form-control" value={this.state.novoProduto.itens} onChange={e => this.setState({ novoProduto: { ...this.state.novoProduto, itens: e.target.value }})} rows={5} required />
                  <small>O item é composto pela sua quantidade, nome e ;. Exemplo: 1 Convite Luxo com Luva;2 Convite Simples sem Embalagem;</small>
                </div>
                <div style={{display: "flex", justifyContent: "flex-end"}}>
                  <button className="btn btn-link" onClick={() => this.setState({ showModalCadastrarProduto: false })} disabled={this.props.itens.carregando}>Cancelar</button>
                  <button className="btn btn-primary" type="submit" disabled={this.props.itens.carregando}>
                    { 
                      this.props.itens.carregando ?
                        <span style={{ display: "flex", alignItems: "center" }}><i style={{ marginRight: 5 }} className="fa fa-spinner fa-spin"/> Carregando</span>
                      : "Cadastrar"
                    }
                  </button>
                </div>
              </form>
            </div>
          </Modal.Body>
        </Modal>
        <Modal show={this.state.showModalEditarProduto}>
          <Modal.Header>
            <Modal.Title>Editar produto</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div>
              <form onSubmit={this.handleSubmitEditarProduto}>
                <div className="form-group">
                  <label htmlFor="input-produto"><span className="perguntaObrigatoria">*</span>Produto</label>
                  <input type="text" id="input-produto" className="form-control" value={this.state.produtoSelecionado.produto} onChange={e => this.setState({ produtoSelecionado: { ...this.state.produtoSelecionado, produto: e.target.value }})} required />
                </div>
                <div className="form-group">
                  <label htmlFor="input-quantidade"><span className="perguntaObrigatoria">*</span>Quantidade</label>
                  <input type="number" id="input-quantidade" className="form-control" value={this.state.produtoSelecionado.quantidade} onChange={e => this.setState({ produtoSelecionado: { ...this.state.produtoSelecionado, quantidade: e.target.value }})} required />
                </div>
                <div className="form-group">
                  <label htmlFor="input-observacao"><span className="perguntaObrigatoria">*</span>Tipo</label>
                  <select id="input-observacao" className="form-control" value={this.state.produtoSelecionado.observacao} onChange={e => this.setState({ produtoSelecionado: { ...this.state.produtoSelecionado, observacao: e.target.value, preco: (e.target.value === "brinde" ? 0 : this.state.produtoSelecionado.preco)}})} required>
                    <option value="avulso">Avulso</option>
                    <option value="brinde">Brinde</option>
                    <option value="kit">Kit</option>
                  </select>
                </div>
                <div className="form-group">
                  <label htmlFor="input-preco"><span className="perguntaObrigatoria">*</span>Preço</label>
                  <input type="text" id="input-preco" className="form-control" value={this.state.produtoSelecionado.preco} onChange={e => this.setState({ produtoSelecionado: { ...this.state.produtoSelecionado, preco: e.target.value }})} required disabled={this.state.produtoSelecionado.observacao === "brinde"} />
                  <small>Utilize o . para valores decimais. Ex: 10.90</small>
                </div>
                <div className="form-group">
                  <label htmlFor="input-descricao"><span className="perguntaObrigatoria">*</span>Descrição</label>
                  <textarea id="input-descricao" className="form-control" value={this.state.produtoSelecionado.descricao} onChange={e => this.setState({ produtoSelecionado: { ...this.state.produtoSelecionado, descricao: e.target.value }})} rows={3} required />
                </div>
                <div className="form-group">
                  <label htmlFor="input-itens"><span className="perguntaObrigatoria">*</span>Itens</label>
                  <textarea id="input-itens" className="form-control" value={this.state.produtoSelecionado.itens} onChange={e => this.setState({ produtoSelecionado: { ...this.state.produtoSelecionado, itens: e.target.value }})} rows={5} required />
                  <small>O item é composto pela sua quantidade, nome e ;. Exemplo: 1 Convite Luxo com Luva;2 Convite Simples sem Embalagem;</small>
                </div>
                <div style={{display: "flex", justifyContent: "flex-end"}}>
                  <button className="btn btn-link" onClick={() => this.setState({ showModalEditarProduto: false })} disabled={this.props.itens.carregando}>Cancelar</button>
                  <button className="btn btn-primary" type="submit" disabled={this.props.itens.carregando}>
                    { 
                      this.props.itens.carregando ?
                        <span style={{ display: "flex", alignItems: "center" }}><i style={{ marginRight: 5 }} className="fa fa-spinner fa-spin"/> Carregando</span>
                      : "Editar"
                    }
                  </button>
                </div>
              </form>
            </div>
          </Modal.Body>
        </Modal>
        <Modal show={this.state.showModalExcluirProduto}>
          <Modal.Header>
            <Modal.Title>Excluir produto</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div>
              <form onSubmit={this.handleSubmitExcluirProduto}>
                <p>Você tem certeza de que deseja excluir este produto? Não será possível reverter esta ação!</p>
                <p>*Caso o produto já tenha sido comprado (ou distribuído) ele não será deletado.</p>
                <div style={{display: "flex", justifyContent: "center"}}>
                  <button className="btn btn-link" onClick={() => this.setState({ showModalExcluirProduto: false })} disabled={this.props.itens.carregando}>Cancelar</button>
                  <button className="btn btn-danger" type="submit" disabled={this.props.itens.carregando}>
                    { 
                      this.props.itens.carregando ?
                        <span style={{ display: "flex", alignItems: "center" }}><i style={{ marginRight: 5 }} className="fa fa-spinner fa-spin"/> Carregando</span>
                      : "Excluir"
                    }
                  </button>
                </div>
              </form>
            </div>
          </Modal.Body>
        </Modal>
      </Modal>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    usuario: state.usuario.autenticado,
    itens: state.item
  }
}

export default connect(mapStateToProps, { editarCamposContrato, adicionarItem, atualizarItem, excluirItem }, null, { forwardRef: true }) (DetalhesModuloPagamento);



// WEBPACK FOOTER //
// ./src/components/DetalhesModuloPagamento.js